import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyRoutingModule } from './survey-routing.module';
import { SurveyComponent } from './survey.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SurveyService } from './survey.service';

@NgModule({
  imports: [
    CommonModule,
    SurveyRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [SurveyComponent],
  exports: [SurveyComponent],
  providers: [SurveyService]
})
export class SurveyModule { }



// WEBPACK FOOTER //
// ./src/app/pages/survey/survey.module.ts